import React, { useEffect, useState } from "react";
import Axios from "axios";
import { GetLeadByID} from "../apiconstants/constants";
import { Link, useLocation } from "react-router-dom";
import Tooltip from 'react-bootstrap/Tooltip';
import OverlayTrigger from 'react-bootstrap/OverlayTrigger';
import LoadingSpinner from '../helpers/loadingspinner';
import parse from "html-react-parser"
import DOMPurify from 'dompurify';
import ConsultantLayout from "../commonlayouts/consultantlayout";
function useQuery() {
    return new URLSearchParams(useLocation().search);
}

const ViewLead = () => {
    let query = useQuery();
    const guid = query.get("guid");
    const LeadID= query.get("data")
    const [candidateDetails, setCandidateDetails] = useState(null);
    const [isLoading, setIsLoading] = useState(false);
 const token = localStorage.getItem("jwtToken");
    const GetCandidateDetails = () => {
        setIsLoading(true);
        const GetapiUrl = `${GetLeadByID.APIURL}?LeadID=${LeadID}`;
        Axios.get(GetapiUrl, { headers: { Authorization: `Bearer ${token}` } })
            .then((result) => {
                setIsLoading(false);
                setCandidateDetails(result.data[0]);
            })
            .catch((error) => {
                console.error("Error fetching candidate details:", error);
            });
    };
  
    useEffect(() => {
        GetCandidateDetails();
    }, []);

    return (
        <ConsultantLayout>
            {candidateDetails ? (
           <div className="container-fluid">
           <div
             className="mb-3 mt-3 mr-3"
             style={{ display: "flex", alignItems: "center" }}
           >
             <Link to="/Employer/ListOfLeads">
               <i
                 className="fa fa-arrow-left mr-3"
                 style={{ color: "#00a7ac", fontSize: 16 }}
                 aria-hidden="true"
               ></i>
             </Link>
             <h2 style={{ color: "#00a7ac", marginLeft: "10px", marginBottom: 0 }}>
               Lead Details
             </h2>
           </div>
           <hr />
     
           <div className="card shadow-lg mt-5 p-5" style={{ border: "none" }}>
             <div className="row mt-2">
               <div className="col-sm-12 col-lg-6 col-xl-6 col-md-6">
                 {/* Full Name */}
                 <OverlayTrigger
                   placement="bottom"
                   overlay={<Tooltip id="tooltip-name">Full Name</Tooltip>}
                 >
                   <p style={{ fontSize: 14, textAlign: 'justify' }}>
                     <i className="fa fa-user" style={iconStyle}></i>{" "}
                     {candidateDetails.fullName}
                   </p>
                 </OverlayTrigger>
     
                 {/* Email */}
                 {candidateDetails.email && (
                   <OverlayTrigger
                     placement="bottom"
                     overlay={<Tooltip id="tooltip-email">Email</Tooltip>}
                   >
                   <p style={{ fontSize: 14, textAlign: 'justify' }}>
                   <i className="fa fa-envelope" style={iconStyle}></i>{" "}
                       {candidateDetails.email}
                     </p>
                   </OverlayTrigger>
                 )}
     
                 {/* Phone Number */}
                 {candidateDetails.phoneNumber && (
                   <OverlayTrigger
                     placement="bottom"
                     overlay={<Tooltip id="tooltip-phone">Phone</Tooltip>}
                   >
                   <p style={{ fontSize: 14, textAlign: 'justify' }}>
                   <i className="fa fa-phone" style={iconStyle}></i>{" "}
                       {candidateDetails.phoneNumber}
                     </p>
                   </OverlayTrigger>
                 )}
     
                 {/* Company Name */}
                 {candidateDetails.companyName && (
                   <OverlayTrigger
                     placement="bottom"
                     overlay={<Tooltip id="tooltip-company">Company</Tooltip>}
                   >
                   <p style={{ fontSize: 14, textAlign: 'justify' }}>
                   <i className="fa fa-building" style={iconStyle}></i>{" "}
                       {candidateDetails.companyName}
                     </p>
                   </OverlayTrigger>
                 )}
     
                 {/* Website URL */}
                 {candidateDetails.websiteURL && (
                   <OverlayTrigger
                     placement="bottom"
                     overlay={<Tooltip id="tooltip-website">Website</Tooltip>}
                   >
                   <p style={{ fontSize: 14, textAlign: 'justify' }}>
                   <i className="fa fa-globe" style={iconStyle}></i>{" "}
                       {candidateDetails.websiteURL}
                     </p>
                   </OverlayTrigger>
                 )}
     
                 {/* LinkedIn URL */}
                 {candidateDetails.linkdinUrl && (
                   <OverlayTrigger
                     placement="bottom"
                     overlay={<Tooltip id="tooltip-linkedin">LinkedIn</Tooltip>}
                   >
                   <p style={{ fontSize: 14, textAlign: 'justify' }}>
                   <i className="fa fa-graduation-cap" style={iconStyle}></i>{" "}
                       <a
                         href={candidateDetails.linkdinUrl}
                         target="_blank"
                         rel="noopener noreferrer"
                         style={{ textDecoration: "none", color: "#00a7ac" }}
                       >
                         {candidateDetails.linkdinUrl}
                       </a>
                     </p>
                   </OverlayTrigger>
                 )}
     
                 {/* Domain */}
                 {candidateDetails.domain && (
                   <OverlayTrigger
                     placement="bottom"
                     overlay={<Tooltip id="tooltip-domain">Domain</Tooltip>}
                   >
                   <p style={{ fontSize: 14, textAlign: 'justify' }}>
                   <i className="fa fa-globe" style={iconStyle}></i>{" "}
                       {candidateDetails.domain}
                     </p>
                   </OverlayTrigger>
                 )}
     
                 {/* Date of Birth */}
                 {candidateDetails.dateOfBirth && (
                   <OverlayTrigger
                     placement="bottom"
                     overlay={<Tooltip id="tooltip-dob">Date of Birth</Tooltip>}
                   >
                   <p style={{ fontSize: 14, textAlign: 'justify' }}>
                   <i className="fa fa-birthday-cake" style={iconStyle}></i>{" "}
                       {candidateDetails.dateOfBirth}
                     </p>
                   </OverlayTrigger>
                 )}
     
               </div>
             </div>
           </div>
         </div>
       ) : (
         <center>
           <LoadingSpinner />
         </center>
       )
     }
     </ConsultantLayout>
    )
}
const iconStyle = {
    fontSize: 14,
    color: "#00a7ac",
    marginRight: 10,
  };
  export default ViewLead;